import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  ar: {
    appName: "إنجلش لاب", tagline: "منصة تعليم الإنجليزية للمدارس",
    login: "تسجيل الدخول", username: "اسم المستخدم", password: "كلمة السر",
    signIn: "دخول", loginHint: "الحسابات ينشئها مدير المنصة فقط",
    logout: "خروج", loading: "جارٍ التحميل...", save: "حفظ", cancel: "إلغاء",
    create: "إنشاء", delete: "حذف", edit: "تعديل", search: "بحث", back: "رجوع",
    owner: "مالك المنصة", school_admin: "أدمن المدرسة", teacher: "معلم", student: "طالب",
    schools: "المدارس", users: "الحسابات", classes: "الصفوف", topics: "المواضيع",
    competitions: "المسابقات", reports: "التقارير", dashboard: "الرئيسية",
    students: "الطلاب", teachers: "المعلمون", grade: "الصف", name: "الاسم",
    fullName: "الاسم الكامل", role: "الدور", school: "المدرسة", city: "المدينة",
    addSchool: "إضافة مدرسة", addUser: "إضافة حساب", addClass: "إنشاء صف",
    bulkImport: "استيراد CSV", resetPassword: "إعادة تعيين كلمة السر",
    members: "الأعضاء", assign: "توزيع", topicsMgmt: "إدارة المناهج",
    video: "رابط الفيديو", referenceBook: "الكتاب المرجعي", words: "الكلمات",
    myClasses: "صفوفي", teachingMode: "وضع التدريس", assignments: "المهام",
    inbox: "صندوق الوارد", worksheets: "أوراق العمل", newAssignment: "مهمة جديدة",
    title: "العنوان", instructions: "التعليمات", submit: "إرسال", grading: "تصحيح",
    aiGrade: "تصحيح بالذكاء الاصطناعي", score: "الدرجة", feedback: "ملاحظات",
    myTasks: "مهامي", games: "الألعاب", quiz: "كويز AI", tutor: "معلم AI",
    writing: "تدريب الكتابة", speaking: "تدريب التحدث", dictionary: "معاني الكلمات",
    points: "النقاط", badges: "الشارات", progress: "التقدم", leaderboard: "لوحة الصدارة",
    startQuiz: "ابدأ الكويز", questions: "عدد الأسئلة", difficulty: "الصعوبة",
    easy: "سهل", medium: "متوسط", hard: "صعب", next: "التالي", finish: "إنهاء",
    correct: "صحيح!", wrong: "خطأ", yourScore: "نتيجتك", play: "العب",
    newTasks: "مهام جديدة", pending: "قيد الانتظار", graded: "مصحح",
    submitted: "تم الإرسال", answerHere: "اكتب إجابتك هنا...",
    askTutor: "اسأل معلم الذكاء الاصطناعي...", send: "إرسال",
    slide: "شريحة", vocabulary: "المفردات", noData: "لا توجد بيانات بعد",
    speakNow: "تحدث الآن", listen: "اسمع", tryAgain: "حاول مرة أخرى",
    generateWorksheet: "توليد ورقة عمل", downloadPdf: "تحميل PDF",
    avgScore: "المعدل", quizzesTaken: "كويزات محلولة", gamesPlayed: "ألعاب لعبتها",
    welcome: "مرحباً", chooseTopic: "اختر موضوعاً", lesson: "الدرس",
    matchGame: "توصيل الكلمات", memoryGame: "بطاقات الذاكرة",
    missingGame: "الحرف الناقص", spellGame: "مسابقة التهجئة",
    speechWarn: "تدريب التحدث يعمل بأفضل شكل على Chrome أو Edge",
    videos: "الفيديوهات", uploadVideo: "رفع فيديو", uploadedVideo: "فيديو مرفوع",
    joinCompetition: "شارك الآن", live: "متاحة الآن", timeLeft: "الوقت المتبقي",
    participants: "المشاركون", competitionDone: "أنهيت المسابقة", meaning: "المعنى",
    example: "مثال", wordHunt: "صيد الكلمات", sentenceBuilder: "بناء الجملة",
    crosswordGame: "تقاطع الكلمات", picSearchGame: "ابحث عن الكلمات", trainGame: "قطار الجُمل",
    listeningMatch: "استماع ومطابقة", branding: "هوية المدرسة", logo: "الشعار",
    primaryColor: "اللون الأساسي", accentColor: "اللون الثانوي", startsIn: "يبدأ بعد",
    alreadyPlayed: "شاركت مسبقاً",
  },
  en: {
    appName: "English Lab", tagline: "English learning platform for schools",
    login: "Login", username: "Username", password: "Password",
    signIn: "Sign in", loginHint: "Accounts are created by the platform owner",
    logout: "Logout", loading: "Loading...", save: "Save", cancel: "Cancel",
    create: "Create", delete: "Delete", edit: "Edit", search: "Search", back: "Back",
    owner: "Owner", school_admin: "School Admin", teacher: "Teacher", student: "Student",
    schools: "Schools", users: "Accounts", classes: "Classes", topics: "Topics",
    competitions: "Competitions", reports: "Reports", dashboard: "Dashboard",
    students: "Students", teachers: "Teachers", grade: "Grade", name: "Name",
    fullName: "Full name", role: "Role", school: "School", city: "City",
    addSchool: "Add school", addUser: "Add account", addClass: "Create class",
    bulkImport: "Import CSV", resetPassword: "Reset password",
    members: "Members", assign: "Assign", topicsMgmt: "Curriculum",
    video: "Video URL", referenceBook: "Reference book", words: "Words",
    myClasses: "My classes", teachingMode: "Teaching Mode", assignments: "Assignments",
    inbox: "Inbox", worksheets: "Worksheets", newAssignment: "New assignment",
    title: "Title", instructions: "Instructions", submit: "Submit", grading: "Grade",
    aiGrade: "AI grade", score: "Score", feedback: "Feedback",
    myTasks: "My tasks", games: "Games", quiz: "AI Quiz", tutor: "AI Tutor",
    writing: "Writing", speaking: "Speaking", dictionary: "Dictionary",
    points: "Points", badges: "Badges", progress: "Progress", leaderboard: "Leaderboard",
    startQuiz: "Start quiz", questions: "Questions", difficulty: "Difficulty",
    easy: "Easy", medium: "Medium", hard: "Hard", next: "Next", finish: "Finish",
    correct: "Correct!", wrong: "Wrong", yourScore: "Your score", play: "Play",
    newTasks: "New tasks", pending: "Pending", graded: "Graded",
    submitted: "Submitted", answerHere: "Write your answer here...",
    askTutor: "Ask the AI tutor...", send: "Send",
    slide: "Slide", vocabulary: "Vocabulary", noData: "No data yet",
    speakNow: "Speak now", listen: "Listen", tryAgain: "Try again",
    generateWorksheet: "Generate worksheet", downloadPdf: "Download PDF",
    avgScore: "Average", quizzesTaken: "Quizzes taken", gamesPlayed: "Games played",
    welcome: "Welcome", chooseTopic: "Choose a topic", lesson: "Lesson",
    matchGame: "Word Match", memoryGame: "Memory Cards",
    missingGame: "Find the Missing", spellGame: "Spelling Bee",
    speechWarn: "Speaking practice works best on Chrome or Edge",
    videos: "Videos", uploadVideo: "Upload video", uploadedVideo: "Uploaded video",
    joinCompetition: "Join now", live: "Live", timeLeft: "Time left",
    participants: "Participants", competitionDone: "Competition finished", meaning: "Meaning",
    example: "Example", wordHunt: "Word Hunt", sentenceBuilder: "Sentence Builder",
    crosswordGame: "Crossword", picSearchGame: "Find the Words", trainGame: "Sentence Train",
    listeningMatch: "Listening Match", branding: "School branding", logo: "Logo",
    primaryColor: "Primary color", accentColor: "Accent color", startsIn: "Starts in",
    alreadyPlayed: "Already played",
  },
};

const Ctx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("el_lang") || "ar");
  useEffect(() => {
    localStorage.setItem("el_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.classList.toggle("font-ar", lang === "ar");
  }, [lang]);
  const t = (k) => dict[lang][k] ?? dict.en[k] ?? k;
  return (
    <Ctx.Provider value={{ lang, setLang, t, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </Ctx.Provider>
  );
};

export const useLang = () => useContext(Ctx);
